import { useMemo } from "react";
import { ArticleCardType, articleCardStyleProps } from "./utils";

export const useGetSizeProps = (type: ArticleCardType) => {
  return useMemo(() => {
    return articleCardStyleProps[type];
  }, [type]);
};
